/**
 * Tokens de superficie: cards, layout (topbar/sidebar/help), tabs y empty states.
 * Fuente de verdad de Fysaro — no mezclar con form-styles (inputs de formulario).
 *
 * Uso:
 *   import { SURFACE_STYLES } from "@/design-system/lib/surface-styles";
 *   <header className={cn("h-16 bg-card", SURFACE_STYLES.topbarBorder)} />
 *
 * Tras actualizar shadcn en ui/, no tocar estilos ahí: aplicar aquí o en módulos.
 */
export const SURFACE_STYLES = {
  /** Opacidad estándar de borde suave (claro/oscuro) */
  borderSoft: "border-border/40",

  // —— Layout shell ——
  topbarBorder: "border-b border-border/40",
  sidebarBorder: "border-r border-border/40",
  sidebarFooterBorder: "border-t border-border/40",
  helpPanelBorder: "border-l border-border/40",
  helpPanelHeaderBorder: "border-b border-border/40",
  dividerVertical: "bg-border/40",

  // —— Cards y paneles ——
  card: "bg-card text-card-foreground rounded-xl border border-border/50 shadow-sm",
  cardInteractive:
    "bg-card text-card-foreground rounded-xl border border-border/50 shadow-sm hover:border-primary/30 hover:shadow-md transition-all duration-300",
  panel: "bg-card text-card-foreground rounded-xl border border-border/50 shadow-sm",
  empty:
    "flex flex-col items-center justify-center rounded-xl border border-dashed border-border/40 bg-secondary/5",
  skeleton: "animate-pulse rounded-lg bg-muted/40",

  // —— Tabs underline (Configuración, listados own/platform, etc.) ——
  tabsListWrap: "border-b border-border/40",
  tabsListBar:
    "bg-transparent h-auto p-0 gap-6 w-full justify-start overflow-x-auto scrollbar-none rounded-none",
  tabsListUnderline:
    "bg-transparent h-auto p-0 gap-6 border-b border-border/40 w-full justify-start rounded-none mb-6 overflow-x-auto scrollbar-none",
  tabTriggerUnderline:
    "data-[state=active]:border-b data-[state=active]:border-primary/70 data-[state=active]:text-primary rounded-none border-b border-transparent px-2 pb-3 pt-0 font-semibold transition-all hover:text-primary/70 flex gap-2 items-center",

  // —— Tabs pill (Radix por defecto) ——
  tabsListPill:
    "inline-flex h-9 items-center justify-center rounded-lg bg-muted/60 p-1 text-muted-foreground",
  tabsTriggerPill:
    "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm data-[state=active]:ring-1 data-[state=active]:ring-border/30",

  /** Cabecera de tabla en skeletons */
  skeletonTableHeader: "border-b border-border/40",

  // —— Detail pages (cabeceras clínica, staff, paciente, profesional) ——
  /** Contenedor: ancho del main en móvil (sin padding lateral extra; usa p-4 del TenantLayout). */
  detailPageShell: "w-full min-w-0 px-0 pb-20 md:max-w-7xl md:mx-auto",
  detailBackButton:
    "mb-4 inline-flex h-8 shrink-0 items-center rounded-md px-3 text-muted-foreground hover:bg-accent hover:text-foreground transition-colors",
  detailHeaderBody: "space-y-6 p-4 md:p-6 lg:p-8",
  detailHeader: "overflow-hidden bg-card rounded-2xl border border-border/50 shadow-sm",
  detailHeaderSection: "border-t border-border/40",
  detailHeaderInset: "rounded-xl border border-dashed border-border/40 bg-muted/30",
  detailHeaderNotes: "rounded-lg border border-dashed border-border/40 bg-muted/20",

  // —— ClinicLanguagePicker ——
  languagePickerShell: "rounded-xl border border-border/50 bg-card/60 p-4 sm:p-5 space-y-5 shadow-sm",
  languagePickerDivider: "border-t border-border/40 pt-4",
  languagePickerOption:
    "rounded-lg border border-border/40 bg-background hover:border-primary/30 hover:bg-accent/40",
  languagePickerOptionActive:
    "border-primary bg-primary text-primary-foreground shadow-sm shadow-primary/10",
  languagePickerChip:
    "rounded-lg border border-border/40 bg-background text-muted-foreground hover:border-primary/30 hover:bg-accent/40",
  languagePickerChipActive: "border-primary/50 bg-primary/10 text-primary shadow-sm",
};
